<script lang="ts">
  import { HackathonPrizeGroup, HackathonPrizeType, type HackathonPrize } from '$shared/lib';
  import Tag from './Tag.svelte';
  import TrophyIcon from '$icons/TrophyIcon.svelte';
  import MedalIcon from '$icons/MedalIcon.svelte';
  import AwardIcon from '$icons/AwardIcon.svelte';
  import StarIcon from '$icons/StarIcon.svelte';

  export let prize: HackathonPrize;
  export let size: 'sm' | 'xs' = 'xs';

  $: icon = (() => {
    switch (prize.group) {
      case HackathonPrizeGroup.GrandPrize:
        return TrophyIcon;
      case HackathonPrizeGroup.TrackPrize:
        return MedalIcon;
      case HackathonPrizeGroup.Award:
        return AwardIcon;
      case HackathonPrizeGroup.HonorableMention:
        return StarIcon;
      default:
        return undefined;
    }
  })();

  $: variant = ((): 'gold' | 'silver' | 'primary' => {
    if (prize.type === HackathonPrizeType.GrandPrize) return 'gold';
    if (prize.type === HackathonPrizeType.HonorableMention) return 'silver';
    return 'primary';
  })();
</script>

<Tag class={$$props.class} {variant} {size} {icon}>
  {prize.name}
</Tag>
